module.exports = __webpack_public_path__ + "static/media/IMG-6700.8ce1e9de.jpg";